import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Route, Switch, Link, RouteComponentProps } from 'react-router-dom';
import History from './history/HistoryView';
import Motorcycles from './motorcycles/MotorcycleView';
import Overview from './overview/Overview';
import './main.scss';
import store from '../../redux/store';
import { exitVehicleConfiguration } from '../../redux/actions';

export class MainView extends React.Component<RouteComponentProps<any>> {
  constructor(props: RouteComponentProps<any>) {
    super(props);
    this.tabSelected = this.tabSelected.bind(this);
  }

  tabSelected(path: Array<string | RegExp>): boolean {
    const { pathname } = this.props.location;
    return path.some((item: string | RegExp) => (typeof item === 'string' ? pathname === item : item.test(pathname)));
  }

  resetVehicleConfiguration() {
    store.dispatch(exitVehicleConfiguration());
  }

  render() {
    const headlineClasses = 'ktm-underlined headline clickable';
    const path = '/main';
    const motoryclesUrl = path + '/motorcycles';
    const historyUrl = path + '/history';
    const overviewUrl = path + '/overview/:modelId';
    return (
      <Grid className='full-height no-flex-wrap' container direction='column'>
        <Grid item id='main-menu-wrapper'>
          <ul id='main-menu-link-list' className='flex-container'>
            <li>
              <h3
                className={`${headlineClasses} ${
                  this.tabSelected([path, path + '/motorcycles', /overview/i]) ? 'selected' : ''
                } `}
              >
                <Link to={motoryclesUrl} onClick={this.resetVehicleConfiguration}>
                  MOTORCYCLES
                </Link>
              </h3>
            </li>
            <li>
              <h3 className={`${headlineClasses} ${this.tabSelected([historyUrl]) ? 'selected' : ''}`}>
                <Link to={historyUrl}>HISTORY</Link>
              </h3>
            </li>
          </ul>
        </Grid>
        <Switch>
          <Route exact path={motoryclesUrl} component={Motorcycles} />
          <Route exact path={historyUrl} component={History} />
          <Route path={overviewUrl} component={Overview} />
          <Route component={Motorcycles} />
        </Switch>
      </Grid>
    );
  }
}

export default MainView;
